import { createAsyncThunk } from '@reduxjs/toolkit';

import { instance } from '../../shared/services/app/instance';
import { setToken } from '../../shared/services/app/instance';

import * as toasty from '../../shared/toastify/toastify';

const fetchAllComplaintsByQuery = createAsyncThunk(
  'expert/fetch/filter',
  async (params, thunkApi) => {
    const { page, limit } = params;

    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.get('/complaints', {
        params: {
          page,
          limit,
        },
      });
      return response.data;
    } catch (error) {
      toasty.toastError(error.response.data.message);
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const fetchTherapistComplaints = createAsyncThunk(
  'therapistComplaints/fetch',
  async ({ _id, page, limit }, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.get(`/complaints/expert/${_id}`, {
        params: {
          page,
          limit,
        },
      });
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const fetchCustomerComplaints = createAsyncThunk(
  'fetchCustomerComplaints/fetch',
  async ({ _id, page, limit }, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.get(`/complaints/user/${_id}`, {
        params: {
          page,
          limit,
        },
      });
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data.message);
    }
  }
);

const complaintsOperations = {
  //   fetchAllExperts,
  fetchAllComplaintsByQuery,
  fetchTherapistComplaints,
  fetchCustomerComplaints,
};

export default complaintsOperations;
